"use client"

import { Card, Col, Row, Skeleton, theme } from "antd"
import Image from "next/image"
import TimmerSkeleton from "./Timmer.skeleton"
import FlashSaleDealsDesktopSkeleton from "./FlashSaleDealsDesktop.skeleton"
import HotelDealItemSkeleton from "./HotelDealItem.skeleton"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"

const FlashSaleDealsSkeleton = () => {
  const token = theme.useToken().token
  const isDesktop = useIsDesktop()

  return (
    <>
      <Col span={24}>
        <Row wrap={false} justify='space-between' align='middle' style={{ marginBottom: '2rem' }}>
          <Col className="home__deals-hotels--box-title" span={isDesktop ? undefined : 24}>
            <Row style={{ marginBottom: 10 }} align='middle' justify='space-between' wrap={false} gutter={[15, 15]}>
              <Image
                height={36}
                width={173.11}
                src={'/static/flash-sale.png'}
                alt="Flash Sale"
                style={{ width: '17.3rem', height: '3.6rem', objectFit: 'contain' }}
              />
              {!isDesktop && (
                <Skeleton
                  paragraph={false}
                  active
                  styles={{
                    title: {
                      margin: 0,
                      width: '8rem',
                      height: '2.2rem'
                    }
                  }}
                />
              )}
            </Row>
            <Row>
              <TimmerSkeleton />
            </Row>
          </Col>
          {isDesktop && (
            <Col>
              <Card
                style={{
                  background: token.colorPrimary
                }}
                styles={{
                  body: {
                    paddingInline: '1rem',
                    paddingBlock: '0.5rem',
                  }
                }}
                size='small'
              >
                <Row style={{ marginBottom: 5 }}>
                  <Skeleton
                    paragraph={false}
                    active
                    styles={{
                      title: {
                        margin: 0,
                        width: '11.2rem',
                        height: '2.4rem'
                      }
                    }}
                  />
                </Row>
                <Row>
                  <Skeleton
                    paragraph={false}
                    active
                    styles={{
                      title: {
                        margin: 0,
                        width: '11.2rem',
                        height: '2.4rem'
                      }
                    }}
                  />
                </Row>
              </Card>
            </Col>
          )}
        </Row>
      </Col>
      <Col style={{ marginBottom: '3rem' }} span={24} className="home__deals-hotels--list-container">
        {isDesktop ? <FlashSaleDealsDesktopSkeleton /> : <HotelDealItemSkeleton />}
      </Col>
    </>
  )
}

export default FlashSaleDealsSkeleton
